import type { SVGProps } from 'react';

const SvgHeartHistoryBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M5.7 3C4.48497 3 3.5 4.00431 3.5 5.24318C3.5 7.48637 6.1 9.52563 7.5 10C8.9 9.52563 11.5 7.48637 11.5 5.24318C11.5 4.00431 10.515 3 9.3 3C8.55594 3 7.89814 3.37663 7.5 3.95311C7.10186 3.37663 6.44406 3 5.7 3Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M13.5 10L16.5 10' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
    <path d='M10.5 13L16.5 13' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
    <path d='M10.5 16L16.5 16' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
    <path
      d='M14 6H18.5C19.0523 6 19.5 6.44772 19.5 7V19C19.5 19.5523 19.0523 20 18.5 20H8.5C7.94772 20 7.5 19.5523 7.5 19V12.5'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
    />
  </svg>
);
export default SvgHeartHistoryBd;
